import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useIdleTimer } from 'react-idle-timer'
import { useDispatch } from 'react-redux'
import { Typography, DialogActions, DialogContent, Dialog, DialogTitle, DialogProps, Button, CssBaseline, ThemeProvider } from '@mui/material'
import { doLogout } from '../../actions/auth/session'
import { AppState } from '../../reducers'
import { SessionState } from '../../reducers/auth/session'
import { IDLE_DEBOUNCE, IDLE_SECONDS, POPUP_SECONDS } from "../../config/config"
import { useTranslation } from 'react-i18next'
import { useThemeContext } from '../../theme/ThemeContext'

interface Props {
  session?: SessionState
  tokenExpired?: boolean
  forceShow?: boolean
}
let logoutTimer: any = null;

const ExpiredSessionInactive: React.FC<Props> = ({ session, tokenExpired, forceShow }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation('login')
  const { theme } = useThemeContext()

  const [showModal, setShowModal] = useState(false);
  const [timeVal, setTimeVal] = useState(0);

  // Combinamos el tokenExpired que venga por prop o por redux
  const tokenExpiredRedux = session?.tokenExpired ?? false
  const tokenExpiredOrForce = tokenExpired || forceShow || tokenExpiredRedux

  const preventBackdropClick = (onClose: () => void): DialogProps['onClose'] => (_event, reason) => {
    if (reason !== 'backdropClick') {
      onClose()
    }
  }

  const onIdle = () => {
    if (session?.email) {
      togglePopup();
      logoutTimer = setTimeout(() => {
        closeAll();
      }, 1000 * POPUP_SECONDS);
    }
  }

  const togglePopup = () => {
    setShowModal((prevState) => !prevState);
  };


  const handleStayLoggedIn = () => {
    if (logoutTimer) {
      clearTimeout(logoutTimer);
      logoutTimer = null;
    }
    togglePopup();
  };

  const { getRemainingTime } = useIdleTimer({
    timeout: 1000 * IDLE_SECONDS,
    onIdle: onIdle,
    debounce: IDLE_DEBOUNCE, // milisegundos 
  });

  // Declare timer that will store the remaining time
  useEffect(() => {
    setInterval(() => {
      setTimeVal(getRemainingTime());
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function closeAll() {
    if (logoutTimer)
      clearTimeout(logoutTimer);
    logoutTimer = null;
    dispatch(doLogout(history))
    setShowModal(false)
  }

  const handleClose = () => {
    closeAll()
  }

  useEffect(() => {
    if (tokenExpiredOrForce) {
      setShowModal(true)
    }
  }, [tokenExpiredOrForce])


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Dialog
        scroll="body"
        maxWidth="sm"
        disableEscapeKeyDown
        open={showModal}
        PaperProps={{ style: { backgroundColor: theme.palette.background.default, color: theme.palette.primary.main } }}
        onClose={preventBackdropClick(togglePopup)}>
        <DialogTitle>
          <Typography component='span' variant="h4">{t('sessionExpired')}</Typography>

        </DialogTitle>
        <DialogContent>
          {!tokenExpiredOrForce && <Typography textAlign='center' variant="h6">{t('sessionExpiredText1')} {(POPUP_SECONDS - (IDLE_SECONDS - (timeVal / 1000))) > 0 ?
            ` ${(POPUP_SECONDS - (IDLE_SECONDS - (timeVal / 1000))).toFixed(0)} ` :
            '...'} {t('sessionExpiredText2')}</Typography>}
          {tokenExpiredOrForce && <Typography textAlign='center' variant="h6">{t('sessionExpiredText4')}</Typography>}
          <Typography textAlign='center' variant="h6">{t('sessionExpiredText3')}</Typography>
        </DialogContent>
        <DialogActions>
          {!tokenExpiredOrForce &&
            <Button variant="contained" sx={{ textTransform: "none", borderRadius: '8px' }}
              onClick={handleStayLoggedIn}>
              {t('continue')}
            </Button>}
          <Button variant="contained" sx={{ textTransform: "none", borderRadius: '8px' }} color="error" onClick={handleClose}>{t('logout')}</Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  )
}

const mapStateToProps = (state: AppState) => ({
  session: state.session,
  tokenExpired: state.session.tokenExpired
})

export default connect(mapStateToProps, null)(ExpiredSessionInactive)
